import { useEffect, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, DatePicker, Button, Descriptions } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import moment from 'moment';
import EndPoints from 'shared/endPoints/EndPoints.json';
import { isDateBefore20Dates } from 'shared/utils/dateUtils';
import useHttpClient from 'shared/hooks/http-hook';

export default function NoPaired() {
  const dateFormat = 'D/M/YYYY';
  const { search } = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(search), [search]);
  const history = useHistory();
  const [form] = Form.useForm();
  const myRef = useRef();
  const { responseData, sendRequest } = useHttpClient();

  const executeScroll = () =>
    myRef.current.scrollIntoView({ behavior: 'smooth' });

  const formItemLayout = {
    labelCol: {
      span: 10
    },
    wrapperCol: {
      span: 12
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      FromDate: queryParams.get('FromDate')
        ? moment(queryParams.get('FromDate'), dateFormat)
        : null,
      ToDate: queryParams.get('ToDate')
        ? moment(queryParams.get('ToDate'), dateFormat)
        : null
    });
    if (form.getFieldValue('FromDate') && form.getFieldValue('ToDate')) {
      sendRequest({
        endpoint: `${
          EndPoints.REPORTS.GETNOPAIRED
        }?${queryParams.toString()}`,
        method: 'GET'
      });
    }
  }, [queryParams, form]);

  const onFinish = fieldsValues => {
    const values = {
      ...fieldsValues,
      FromDate: fieldsValues.FromDate?.format(dateFormat),
      ToDate: fieldsValues.ToDate?.format(dateFormat)
    };
    Object.keys(values).forEach(key =>
      values[key] === null || values[key] === undefined || values[key] === ''
        ? delete values[key]
        : values[key]
    );
    const params = new URLSearchParams(values);
    history.replace({ search: `?${params}` });
    sendRequest({
      endpoint: `${
        EndPoints.REPORTS.GETNOPAIRED
      }?${params}`,
      method: 'GET'
    });
    executeScroll();
  };

  return (
    <>
      <Card
        type="inner"
        headStyle={headerStyle}
        title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση"
      >
        <Row style={rowStyle}>
          <Col style={{ color: 'black' }} span={24}>
            Κριτήρια Αναζήτησης
          </Col>
        </Row>
        <Form {...formItemLayout} form={form} onFinish={onFinish}>
          <Row>
            <Col span={12}>
              <Form.Item
                name="FromDate"
                label="Ημερομηνία Από:"
                rules={[
                  {
                    required: true,
                    message: 'Το πεδίο είναι απαραίτητο'
                  }
                ]}
              >
                <DatePicker
                  disabledDate={isDateBefore20Dates}
                  data-testid="FromDate"
                  style={{ width: '70%' }}
                  format={dateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="ToDate"
                label="Ημερομηνία Έως:"
                rules={[
                  {
                    required: true,
                    message: 'Το πεδίο είναι απαραίτητο'
                  }
                ]}
              >
                <DatePicker
                  disabledDate={isDateBefore20Dates}
                  data-testid="ToDate"
                  style={{ width: '70%' }}
                  format={dateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={8} offset={10}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  style={{ backgroundColor: '#e6e6e6' }}
                >
                  Αναζήτηση
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      {responseData && (
        <Row justify="center" align="middle">
          <Col span={20}>
            <Descriptions
              title={`Συνολικός αριθμός: ${responseData?.totalCount}`}
              column={2}
              size="middle"
              bordered
              labelStyle={{ fontSize: 16 }}
              contentStyle={{ fontSize: 18, fontWeight: 'bold' }}
            >
              <Descriptions.Item label="Αριθμός NoPaired">
                {responseData?.noPairedCount}
              </Descriptions.Item>
              <Descriptions.Item label="Αριθμός NoLogin">
                {responseData?.noLoginCount}
              </Descriptions.Item>
              <Descriptions.Item label="NoPaired Ποσοστό">
                {responseData?.noPairedPercentage}%
              </Descriptions.Item>
              <Descriptions.Item label="NoLogin Ποσοστό">
                {responseData?.noLoginPercentage}%
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      )}
    </>
  );
}
